import * as types from "../types/index";
import { setInitialState } from "../InitialState";

const INITIAL_STATE = setInitialState({
  data: null,
});

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case types.ASSESSMENT_CONGRATULATION_REQUEST:
      return {
        ...state,
        isFetching: true,
        isError:false,
        isSuccess: false,
      };
    case types.ASSESSMENT_CONGRATULATION_RECEIVE:
      return {
        ...state,
        isFetching: false,
        isError: false,
        isSuccess: true,
        data: action.payload.success,
      };
    case types.ASSESSMENT_CONGRATULATION_FAILURE:
      return {
        ...state,
        isFetching: false,
        isSuccess: false,
        isError: true,
        data: action.payload.response,
      };
    case types.RESET_ASSESSMENT_CONGRATULATION:
      return {
        ...state,
        isFetching: false,
        isSuccess: false,
        isError: false,
        data: null,
      };
    default:
      return {
        ...state,
      };
  }
}
